import api from '@/api/index'

export default {
  get: async payload => {
    const response = await api.log.get(payload)
    const { data } = response
    return data
  },
}
